import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineTextUI } from "./InlineEditor.js";
import { useState, useEffect } from "react";
export function LinkUI({ element, value, selected, updateData, close, ...props }) {
    const [href, setHref] = useState(value.href);
    function onMouseEnter() {
        element.removeAttribute("href");
    }
    function onMouseLeave() {
        element.setAttribute("href", href);
    }
    useEffect(() => {
        element.addEventListener("mouseenter", onMouseEnter);
        element.addEventListener("mouseleave", onMouseLeave);
        return () => {
            element.removeEventListener("mouseenter", onMouseEnter);
            element.removeEventListener("mouseleave", onMouseLeave);
        };
    }, []);
    function onClose(e) {
        if (element.contains(e.relatedTarget))
            return;
        if (href !== value.href)
            updateData({ ...value, href });
        close();
    }
    return (_jsxs("div", { onBlur: onClose, children: [selected && (_jsx("div", { className: "Launched__tag-linkInput", children: _jsx("input", { className: "", type: "text", value: href, placeholder: "Enter a URL...", onChange: (e) => setHref(e.target.value), onBlur: () => {
                        if (href !== value.href)
                            updateData({ ...value, href });
                    } }) })), _jsx(InlineTextUI, { ...props, value: value.text, updateData: (text) => updateData({ ...value, text }), element: element, selected: selected, close: () => { } })] }));
}
export const LinkRenderer = {
    component: (props) => {
        return _jsx(LinkUI, { ...props });
    },
    parentValidator: (el) => {
        return el.nodeName === "A";
    },
    getStaticProperties: (el) => ({
        text: el.textContent || "",
        href: el.getAttribute("href") || "",
    }),
    updateStaticProperties: ({ element, data }) => {
        const textNode = element.firstChild;
        if (textNode)
            textNode.textContent = data.text;
        element.setAttribute("href", data.href);
    },
};
